import "./index.css";

import { NotFound } from "@repo/ui";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { ParcoursGuard } from "./components/parcours-guard";
import { ParcoursView } from "./routes/parcours-view";

const router = createBrowserRouter([
  // Candidate route - lightweight authentication (lastName + parcoursId)
  {
    path: "/p/:id",
    element: <ParcoursGuard />,
    children: [
      {
        index: true,
        element: <ParcoursView />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}

export default App;
